<template>
	<div>
		<!-- visible -->
		<div v-if="errors2" ref="error-container" class="message-panel-errors">
			<template v-for="(error, key) in errors2">
				<template v-if='!inline.find(value => {return key.match(new RegExp(value))})'>
					<p :key='"" + key + "-" + mkey' class="_error alert alert-warning" v-for="(message, mkey) in error">
						<span v-html='autobrand(message)'></span>
					</p>
				</template>
			</template>
		</div>

		<!-- screen-reader only -->
		<div v-if="errors2" ref="error-container-sronly" class="sr-only" aria-live="assertive" role="alert">
			<template v-for="(error, key) in errors2">
				<p :key='"" + key + "-" + mkey' class="_error alert alert-warning" v-for="(message, mkey) in error">
					<span class="">Error:</span>
					<span v-html='autobrand(message)'></span>
				</p>
			</template>
		</div>

	</div>
</template>

<script>
	/**
	 * Message types:
	 *
	 * success
	 * info
	 * warning
	 * danger
	 */

	export default {
		props: {
			"inline": {

            },
            "errors": {
				default: null
			},
			"sronly": {
				default: false
			}

        },
		data: function(){
			return {
			};
		},
		computed: {
            errors2() {
				if(this.errors) {
					return this.errors;
				}
				else {
					return this.$parent.errors;
				}
			}
		},
		methods: {
		}
    }
</script>
